/**
 * InMobi Choice loader.
 *
 * Reuses the existing kueez InMobi property URL — same tag yoto-web and
 * `ecom-redirect-cf-worker` already serve. The script registers `__tcfapi` on
 * the page; once that happens, the consent engine reads consent through the
 * normal TCF path (`tcf.ts`).
 *
 * Idempotent: subsequent calls are no-ops.
 */

import { debug, warn } from '../../util/log';

const TAG_URL = 'https://cmp.inmobi.com/choice/nCMHNG-AK-juF/kueez.com/choice.js?tag_version=V3';

let loaded = false;

export function loadInMobiChoice(): void {
  if (loaded) return;
  loaded = true;
  if (typeof document === 'undefined') return;
  try {
    const script = document.createElement('script');
    script.src = TAG_URL;
    script.async = true;
    script.onerror = () => warn('inmobi script failed to load');
    (document.head || document.documentElement).appendChild(script);
    debug('inmobi script injected');
  } catch (err) {
    warn('inmobi load threw', err);
  }
}

/** Test-only — clears the module-level `loaded` flag. */
export function _resetInMobiForTests(): void {
  loaded = false;
}
